import { useEffect } from "react";
import { useFormikContext } from "formik";

const ScrollToFirstError = () => {
  const { isValid, submitCount } = useFormikContext();

  useEffect(() => {
    if (submitCount > 0 && !isValid) {
      requestAnimationFrame(() => {
        const firstError = document.querySelector<HTMLElement>(
          ".input__error, .calendar-input__error",
        );
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }
  }, [submitCount, isValid]);

  return null;
};

export default ScrollToFirstError;
